import browser from '@openclassrooms/utils/browser';

export function isProd() {
  return browser?.window?.location.host === 'openclassrooms.com';
}

export function isBugBounty() {
  return Boolean(browser?.window?.location.host.match(/^bugbounty/));
}

// testing.openclassrooms.com is used for our bug bountry program
export function isStage() {
  return (
    Boolean(browser?.window?.location.host.match(/^stage/)) ||
    Boolean(browser?.window?.location.host.match(/^staging/)) ||
    Boolean(browser?.window?.location.host.match(/^bugbounty/))
  );
}

export function isPreprod() {
  return Boolean(browser?.window?.location.host.match(/^preprod/));
}

export function isOnTheFlyStage() {
  return Boolean(browser?.window?.location.host.match(/stage-oc-\d+/));
}

export function isNotStage() {
  return !isStage();
}

export function isNotProd() {
  return !isProd();
}

export function isDev() {
  return isNotStage() && isNotProd();
}

export function isNotDev() {
  return !isDev();
}

export function isDemo() {
  return Boolean(browser?.window?.location.host.match(/^demo/));
}

export type Environment = 'dev' | 'stage' | 'preprod' | 'prod' | 'demo' | 'bugbounty';
export function getEnvironment(): Environment {
  if (isProd()) {
    return 'prod';
  }

  if (isBugBounty()) {
    return 'bugbounty';
  }

  if (isPreprod()) {
    return 'preprod';
  }

  if (isStage() || isOnTheFlyStage()) {
    return 'stage';
  }

  if (isDemo()) {
    return 'demo';
  }

  return 'dev';
}
